var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFutureRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19C4.67267 19 4 18.3273 4 17.5V6.5C4 5.67267 4.67267 5 5.5 5H8V3.5C8 3.224 8.224 3 8.5 3C8.776 3 9 3.224 9 3.5V5H15V3.5C15 3.224 15.224 3 15.5 3C15.776 3 16 3.224 16 3.5V5H18.5C19.3273 5 20 5.67267 20 6.5V17.5C20 18.3273 19.3273 19 18.5 19H5.5ZM5 17.5C5 17.776 5.224 18 5.5 18H18.5C18.776 18 19 17.776 19 17.5V10H5V17.5ZM19 9V6.5C19 6.224 18.776 6 18.5 6H16V7C16 7.276 15.776 7.5 15.5 7.5C15.224 7.5 15 7.276 15 7V6H9V7C9 7.276 8.776 7.5 8.5 7.5C8.224 7.5 8 7.276 8 7V6H5.5C5.224 6 5 6.224 5 6.5V9H19Z",
    fill: "#FECE29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13C8.16421 13 8.5 12.6642 8.5 12.25C8.5 11.8358 8.16421 11.5 7.75 11.5C7.33579 11.5 7 11.8358 7 12.25C7 12.6642 7.33579 13 7.75 13Z",
    fill: "#FECE29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 16.5C8.16421 16.5 8.5 16.1642 8.5 15.75C8.5 15.3358 8.16421 15 7.75 15C7.33579 15 7 15.3358 7 15.75C7 16.1642 7.33579 16.5 7.75 16.5Z",
    fill: "#FECE29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12.4142 13 12.75 12.6642 12.75 12.25C12.75 11.8358 12.4142 11.5 12 11.5C11.5858 11.5 11.25 11.8358 11.25 12.25C11.25 12.6642 11.5858 13 12 13Z",
    fill: "#FECE29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C12.4142 16.5 12.75 16.1642 12.75 15.75C12.75 15.3358 12.4142 15 12 15C11.5858 15 11.25 15.3358 11.25 15.75C11.25 16.1642 11.5858 16.5 12 16.5Z",
    fill: "#FECE29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13C16.6642 13 17 12.6642 17 12.25C17 11.8358 16.6642 11.5 16.25 11.5C15.8358 11.5 15.5 11.8358 15.5 12.25C15.5 12.6642 15.8358 13 16.25 13Z",
    fill: "#FECE29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.5C15.8367 16.5 15.5 16.1633 15.5 15.75C15.5 15.3367 15.8367 15 16.25 15C16.2593 15 16.27 15.0007 16.2807 15.002C16.2873 15.0027 16.2933 15.0033 16.2987 15.004C16.6873 15.0233 17 15.3513 17 15.7507C17 16.1633 16.6633 16.5 16.25 16.5Z",
    fill: "#FECE29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureRate);
export default __webpack_public_path__ + "static/media/future-rate.a3d3c239.svg";
export { ForwardRef as ReactComponent };